/**
 * @generated SignedSource<<2dda6e3650b409a1a7c69f45de2406d8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue$data = {
  readonly redactedFields: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId: string | null | undefined;
        readonly typeKey: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue";
};
export type onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue$key = {
  readonly " $data"?: onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "onboarding_issueViewRedaction_RedactionOnboardingSpotlight_issue",
  "selections": [
    {
      "concreteType": "JiraFieldConnection",
      "kind": "LinkedField",
      "name": "redactedFields",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraFieldEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraField",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "fieldId"
                },
                {
                  "kind": "ScalarField",
                  "name": "typeKey"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "3f49fa3ad83dc768dae3ca7ef1527e31";

export default node;
